export const legacyPointChargeMock = {
  phone: '010-0000-0000',
  usableRate: 0.9,
} as const
